'use client';

import { useState, useEffect } from 'react';

import Icon from '@/components/ui/AppIcon';

const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2024');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  const footerLinks = {
    product: [
    { label: 'Clinical Evidence', href: '#clinical-evidence' },
    { label: 'Device Technology', href: '#device-technology' },
    { label: 'Implementation', href: '#implementation' },
    { label: 'Pricing', href: '#implementation' }],

    resources: [
    { label: 'Research Publications', href: '#clinical-evidence' },
    { label: 'Case Studies', href: '#social-proof' },
    { label: 'Technical Documentation', href: '#device-technology' },
    { label: 'FAQ', href: '#faq' }],

    company: [
    { label: 'About REVIVE', href: '#' },
    { label: 'Medical Advisory Board', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Press & Media', href: '#' }],

    legal: [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Service', href: '#' },
    { label: 'HIPAA Compliance', href: '#' },
    { label: 'Regulatory Approvals', href: '#' }]

  };

  const certifications = [
  { name: 'ISO 13485', icon: 'DocumentCheckIcon' }];


  return (
    <footer className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="flex items-center justify-center w-10 h-10 bg-primary-foreground/10 rounded-lg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-primary-foreground">

                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                    fill="currentColor" />

                  <circle cx="12" cy="12" r="3" fill="currentColor" />
                  <path
                    d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                    fill="currentColor"
                    opacity="0.5" />

                </svg>
              </div>
              <span className="font-bold font-heading text-lg">Sensivision Health Technologies Pvt. Ltd.</span>
            </div>
            <p className="text-sm opacity-80 mb-6 leading-relaxed">
              Revolutionary medical device technology protecting newborn minds and securing future potential through advanced neonatal brain complication treatment solutions.
            </p>
            <div className="flex flex-wrap gap-3">
              {certifications.map((cert, index) =>
              <div key={index} className="flex items-center space-x-2 bg-primary-foreground/10 px-3 py-2 rounded-lg">
                  <Icon name={cert.icon as any} size={16} />
                  <span className="text-xs font-semibold">{cert.name}</span>
                </div>
              )}
            </div>
          </div>

          <div>
            <h3 className="font-bold mb-4">Product</h3>
            <ul className="space-y-2">
              {footerLinks.product.map((link, index) =>
              <li key={index}>
                  <a
                  href={link.href}
                  className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">

                    {link.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4">Resources</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link, index) =>
              <li key={index}>
                  <a
                  href={link.href}
                  className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">

                    {link.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4">Company</h3>
            <ul className="space-y-2 mb-6">
              {footerLinks.company.map((link, index) =>
              <li key={index}>
                  <a
                  href={link.href}
                  className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">

                    {link.label}
                  </a>
                </li>
              )}
            </ul>
            <h3 className="font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link, index) =>
              <li key={index}>
                  <a
                  href={link.href}
                  className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">

                    {link.label}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm opacity-80">
              &copy; {isHydrated ? currentYear : '2024'} Sensivision Health Technologies Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">
                Contact Support
              </a>
              <a href="#" className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">
                Medical Device Safety
              </a>
              <a href="#" className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-250 ease-out">
                Adverse Event Reporting
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;